/* AA: mobile add-to-cart confirmation — YSL-style bottom sheet showing ONLY the just-added
   product and a "View Cart (N)" button linking to the cart page. On <990px it replaces the
   cart drawer OPENING after an add; renderContents still runs in full (drawer + header
   bubble stay fresh), only the open() call is intercepted. Desktop keeps the drawer.
   Content is cloned from the just-rendered drawer row (image / aa-cart-item__title / meta /
   price), so formatting and metafield logic stay single-source. Covers quick-add too (it
   goes through the same renderContents). Loaded from snippets/cart-drawer.liquid. */
(function () {
  var MQ = window.matchMedia('(max-width: 989.98px)');
  var root = null;

  function build() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'aa-added';
    root.innerHTML =
      '<div class="aa-added__scrim"></div>' +
      '<div class="aa-added__sheet" role="dialog" aria-modal="true" aria-label="Product added to the cart">' +
        '<button type="button" class="aa-added__handle" aria-label="Close"></button>' +
        '<div class="aa-added__head">' +
          '<div class="aa-added__heading">Product Added to the Cart</div>' +
        '</div>' +
        '<div class="aa-added__item">' +
          '<div class="aa-added__media"></div>' +
          '<div class="aa-added__info"></div>' +
        '</div>' +
        '<div class="aa-added__actions">' +
          '<a class="aa-added__view" href="#">View Cart</a>' +
          '<a class="aa-added__checkout" href="/checkout">Go to checkout</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    root.querySelector('.aa-added__view').setAttribute(
      'href',
      (window.routes && window.routes.cart_url) || '/cart'
    );
    root.querySelector('.aa-added__scrim').addEventListener('click', close);
    root.querySelector('.aa-added__handle').addEventListener('click', close);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') close();
    });
    return root;
  }

  function close() {
    if (root) root.classList.remove('is-open');
  }

  function show(drawer) {
    var item =
      drawer.querySelector('.cart-item[data-product-id="' + drawer.productId + '"]') ||
      drawer.querySelector('.cart-item'); /* newest line renders first */
    if (!item) return;
    var el = build();

    var media = el.querySelector('.aa-added__media');
    media.innerHTML = '';
    var img = item.querySelector('.cart-item__media img');
    if (img) media.appendChild(img.cloneNode(true));

    var info = el.querySelector('.aa-added__info');
    info.innerHTML = '';
    [
      { sel: '.aa-cart-item__title', cls: 'aa-added__title' },
      { sel: '.aa-cart-item__meta', cls: 'aa-added__meta' },
      { sel: '.aa-cart-item__price', cls: 'aa-added__price' }
    ].forEach(function (part) {
      var src = item.querySelector(part.sel);
      if (!src) return;
      var d = document.createElement('div');
      d.className = part.cls;
      Array.prototype.forEach.call(src.childNodes, function (n) {
        d.appendChild(n.cloneNode(true));
      });
      info.appendChild(d);
    });

    /* Total item count from the freshly re-rendered header bubble — already "(N)". */
    var count = '';
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
    if (bubble && bubble.textContent.indexOf('(') !== -1) {
      count = ' ' + bubble.textContent.trim();
    }
    el.querySelector('.aa-added__view').textContent = 'View Cart' + count;

    requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Mobile: the header cart icon NAVIGATES to the cart page instead of opening the
     drawer. cart-drawer.js binds click on #cart-icon-bubble (an <a href="/cart">) and
     preventDefaults; this capture-phase listener stops that handler before it runs, so
     the anchor's default navigation goes through. Desktop keeps the drawer. */
  document.addEventListener(
    'click',
    function (e) {
      if (!MQ.matches) return;
      if (e.target.closest && e.target.closest('#cart-icon-bubble')) e.stopPropagation();
    },
    true
  );

  onReady(function () {
    var CartDrawerEl = customElements.get('cart-drawer');
    if (!CartDrawerEl) return;
    var origOpen = CartDrawerEl.prototype.open;
    var origRender = CartDrawerEl.prototype.renderContents;
    /* renderContents ends in setTimeout(() => this.open()), so flag the instance here and
       swallow that one open() call on mobile. A user-click open (cart icon) has no flag and
       behaves normally. */
    CartDrawerEl.prototype.renderContents = function (parsedState) {
      if (MQ.matches) this.__aaSheet = true;
      return origRender.call(this, parsedState);
    };
    CartDrawerEl.prototype.open = function () {
      if (this.__aaSheet) {
        this.__aaSheet = false;
        show(this);
        return;
      }
      return origOpen.apply(this, arguments);
    };
  });
})();
